module.exports = __webpack_public_path__ + "img/close-lake.eaea6b7f.svg";